import React from "react";

/*
    Search Icon
    props:
        - title: string, override the default title 'Search'
        - color: string, override the default color '#00549A' (bell blue)
*/

const SearchIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Search"}</title>
        <path
            d="M14.9531 14.9531L20.25 20.25M16.8752 10.3126C16.8752 13.9374 13.9371 16.8752 10.312 16.8752C6.68811 16.8752 3.75 13.9374 3.75 10.3126C3.75 6.68785 6.68811 3.75 10.312 3.75C13.9371 3.75 16.8752 6.68785 16.8752 10.3126Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SearchIcon;
